export default "__VITE_ASSET__lnUX61N$__"